import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ContractTerm, TermItem } from './contract-invoices.model';

@Component({
    selector: 'term-rates-and-fees',
    template: `
        @if (term && term.contingencyPct) {
            <span
                >{{ usePercent ? (term.contingencyPct | percent: '1.1-2') : term.contingencyPct }}
                @if (!usePercent) {
                    <span>%</span>
                }
                contingency fee
                @if (term && term.contingencyCap !== undefined && term.contingencyCap !== null) {
                    <span>capped at {{ term.contingencyCap | currency: 'USD' }}</span>
                }
                @if (term.flatFee || term.hourlyRate) {
                    <span>;</span>
                }
            </span>
        }
        @if (term && term.flatFee) {
            <span
                >{{ term.flatFee | currency: 'USD' }} fixed fee
                @if (term.hourlyRate) {
                    <span>;</span>
                }
            </span>
        }
        @if (term && term.hourlyRate) {
            <span>{{ term.hourlyRate | currency: 'USD' }} hourly rate</span>
        }
    `,
    imports: [CommonModule],
})
export class TermRatesAndFeesComponent {
    @Input() term: ContractTerm | TermItem;
    @Input() usePercent: boolean;
}
